import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-feedback-stats-daily',
  templateUrl: './feedback-stats-daily.component.html',
  styleUrls: ['./feedback-stats-daily.component.css']
})
export class FeedbackStatsDailyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
